import * as types from "../actionTypes/PaymentActionsType";
import axios from "../../Uri"
export const dailyIncome=(buildingId)=>(dispatch)=>{
    axios.get(`payment/getTodaysIncome/${buildingId}`).then((res)=>{
        dispatch({type:types.DAILY_INCOME,payload:res.data});
    }).catch((err)=>{
        console.log(err);
    })
}
export const getRecentTransaction = (buildingId) => (dispatch) => {
    axios
      .get(`/payment/recentTransactions/${buildingId}`)
      .then((response) => {
        dispatch({ type: types.RECENT_TRANSACTION, payload: response.data });
      })
      .catch((error) => {
        console.log(error);
        });
  };
  export const todayIncomeTable=(id)=>(dispatch)=>{
    axios.get(`/payment/todayPayment/${id}`).then((res)=>{
        dispatch({type:types.TODAYINCOME_TABLE,payload:res.data})
    })
    .catch((err)=>{
        console.log(err)
    })
  }
export const showTodaIncometable=()=>(dispatch)=>{
    dispatch({type:types.SHOW_TODAY_INCOME})

}

export const allTransactionData=(pageNumber) => (dispatch) => {
  axios.get(`/payment/posts?pageNumber=${pageNumber}&pageSize=25&sortBy=id&sortDir=desc`).then((response)=> {
    const apiRes = response.data.content;
    console.log(apiRes);
    dispatch({type:types.ALL_TRANSACTION,payload:apiRes})
  }).catch((error)=>{
    console.log(error);
  });
  }